import { createReducer } from './util';
import {
  UPDATE_EXAMINATION_RESULT, UPDATE_FACE_RESULT,
  UPDATE_TONGUE_RESULT,
} from '../actions/result';

export const resultInitialState = {
  result: {
    face: null,
    tongue: null,
    examination: null,
  }
};

export const result = createReducer(
  resultInitialState.result,
  {
    [UPDATE_EXAMINATION_RESULT]: (_, action) => ({ examination: action.result }),
    [UPDATE_FACE_RESULT]: (_, action) => ({ face: action.result }),
    [UPDATE_TONGUE_RESULT]: (_, action) => ({ tongue: action.result }),
  },
);



// WEBPACK FOOTER //
// ./src/reducers/result.js